import React from 'react';

import BaseIcon from '../BaseIcon';

export const Service = (props) => (
    <BaseIcon {...props} viewBox="0 0 1000 1000">
        <path
            d="M303,58.5c50.8,50.8,63.3,125.4,37.3,187.8l411.8,412.5c62.4-26.1,137-13.9,187.7,36.8c66.9,67,66.9,175.7,0,243.1c-66.9,
            67-175.6,67-243,0C646.1,888,634,813.4,660,750.9l-412.3-412c-62.4,25.6-137,13.5-187.3-37.3C18.7,260.3,3,202.7,12.9,149.3l129.3,
            129.4l137.9-137.9L150.7,11.3C204.2,1.4,261.7,17.2,303,58.5L303,58.5z M898.9,897.4l-55.2,14.8l-54.8,
            14.8l-40-40.4l-40.4-40l14.8-54.8l14.8-54.8l54.8-14.8l54.8-14.8l40.4,40l40,40.4l-14.8,54.8L898.9,897.4z"
        />
        <path
            d="M522.6,318.2l162.6,162.7c10.3,10.3,10.3,27,0,37.3l0,0c-9.9,9.9-27,9.9-36.8,0l-163-163.1c-9.9-9.9-9.9-27,0-36.8l0,0C495.6,
            307.9,512.3,307.9,522.6,318.2L522.6,318.2z M880.5,163.2L630.8,413l-51.2-50.8l250.2-249.8l-21.6-21.6L930.8,9.1l18.4,18l16.6,
            16.6l18,18l-81.7,123.1L880.5,163.2z M501.9,646.2L160.2,988.2c-4.5,4.5-12.1,4.5-17.1,0l-128.9-129c-4.5-4.9-4.5-12.6,
            0-17.1l342.2-341.9l13.5,13.5L62.3,821.5c-3.6,4.1-3.6,9.9,0,13.9l0,0c3.6,3.6,9.9,3.6,13.5,0l307.6-307.8l38.6,38.2L114.4,
            873.6c-3.6,4-3.6,9.9,0,13.9l0,0c3.6,3.6,9.9,3.6,13.5,0l307.6-307.8l39.1,39.1L166.9,926.6c-3.6,3.6-3.6,9.9,0,13.5l0,0c4,
            3.6,9.9,3.6,13.9,0l307.6-307.8L501.9,646.2z"
        />
    </BaseIcon>
);
